import * as priceFragments from '@/services/price/fragments';

export default `
mutation update_material(
  $material: [material_insert_input!]!
  $delete_vendor_ids: [uuid!]!
  ${priceFragments.mutationArgs}
) {
  ${priceFragments.mutations}

  insert_material(
    objects: $material,
    on_conflict: {
      constraint: material_pkey,
      update_columns: [
        name
        care
        color
        composition
        notes
        origin
        properties
        shrinkage
        thickness
        weight
        width
        sym_bleach
        sym_dry_clean_solvent
        sym_drying
        sym_ironing_temp
        sym_tumble_dry
        sym_wash
      ]
    }
  ) {
    affected_rows
    returning {
      id
    }
  }

  delete_vendor_material(
    where: {
      id: {
        _in: $delete_vendor_ids
      }
    }
  ) {
    affected_rows
    returning {
      id
    }
  }
}
`;
